export const validateName = (val: string | undefined) => {
  if (!val?.length) {
    return "Наименование не может быть пустым";
  }
  return;
};

export const validateRequired = (val: string | undefined) => {
  if (!val?.toString().length) {
    return "Поле обязательно";
  }
  return;
};

export const validatePrice = (val: string | undefined) => {
  // Цена не обязательна для заполнения
  if (!val?.toString().length) return;
  if (isNaN(parseFloat(val))) {
    return "Введите число";
  }
  if (parseFloat(val) < 0) {
    return "Цена не может быть отрицательной";
  }
  return;
};